import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Box, Typography } from '@lyearn/ui';
import { OrgRoleTypeEnum } from '@/types/schema';

import OrgRoleSearch from './OrgRoleSearch';
import { OrganizationRoleProps } from './types';

const DESIGNATION_TYPE_FILTER = [OrgRoleTypeEnum.Designation];

function OrganizationRole({ orgRoleId, onChange, user }: OrganizationRoleProps) {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography className="mb-8 ms-8" variant="body-short-02">
        {t('Common:Filter.Designation')}
      </Typography>

      <OrgRoleSearch
        orgRoleId={orgRoleId}
        placeholder={t('Admin:InviteStaff.DesignationPlaceholder')}
        type={DESIGNATION_TYPE_FILTER}
        user={user}
        onChange={onChange}
      />
    </Box>
  );
}

export default OrganizationRole;
